import React, { useContext, useState, useEffect } from "react";
import { Context } from "../utils/context";
import axios from "axios";
import { BASE_URL } from "../utils/BaseURL";

const Success = () => {
  const {
    orderRoutes,
    setorderRoutes,
    formData,
    cartItems,
    total,
    cartSubTotal,
  } = useContext(Context);
  const { user } = JSON.parse(localStorage.getItem("user")) || {};

  const productIds = cartItems?.map((product) => product._id);

  useEffect(() => {
    const postData = {
      shippingInfo: {
        address: "123 Main St",
        city: "New York",
        state: "NY",
        country: "USA",
        pincode: 12345,
        phoneNo: 1234567890,
      },
      orderItems: productIds,
      user: user._id, // Replace with actual user ID
      paymentInfo: {
        id: "paymentId123",
        status: "Paid",
      },
      paidAt: "2023-10-31T12:00:00Z",
      totalPrice: cartSubTotal,
      orderStatus: "Processing",
    };
    console.log(postData);

    axios
      .post(BASE_URL + "/orders", postData)
      .then((response) => {
        console.log("Order created successfully:", response.data);
      })
      .then(setorderRoutes(false))
      .catch((error) => {
        console.error("Error creating order:", error);
      });
  }, []);

  // console.log(form)
  return <div className="min-h-screen">Success</div>;
};

export default Success;
